import { useMemo } from 'react'

export const useGetResmanOptions = (resmanConfig) => {
  return useMemo(() => {
    if (!resmanConfig) {
      return {
        categories: [],
        areas: [],
        locations: [],
        priorities: [],
      }
    }

    return {
      categories: resmanConfig.categories.map((category) => ({
        value: category.categoryId,
        id: category.categoryId,
        text: category.name,
      })),
      areas: resmanConfig.areas.map((area) => ({
        value: area,
        id: area,
        label: area,
      })),
      locations: resmanConfig.locations.map((location) => ({
        value: location.id,
        id: location.id,
        text: location.name,
      })),
      priorities: resmanConfig.priorities.map((priority) => ({
        value: priority,
        id: priority,
        text: priority,
      })),
    }
  }, [resmanConfig])
}
